import axios from 'axios';
import { getISODate } from '@/lib/utils';

const headers = {
  headers: {
    Authorization: window.localStorage.getItem('token'),
  },
};
const origin = `${process.env.VUE_APP_ORIGIN}`;
const prefix = 'api';
const originPath = `${origin}/${prefix}/admins/chats`;
const routes = {
  get: {
    chats: originPath,
    chatsByDate: `${originPath}ByDate`,
    vatAgreementUserIds: `${origin}/${prefix}/admins/vat-agreement-user-ids`,
  },
};

export const getRoutes = () => {
  return routes;
};

export const getAll = (query = {}) => {
  let params = Object.keys(query).length
    ? `?${new URLSearchParams(query).toString()}`
    : '';

  const url = routes.get.chats + params;
  return axios.get(url, headers);
};

export const getChatsByDate = ({ date = getISODate(new Date()) }) => {
  const params = `?${new URLSearchParams({
    date,
  }).toString()}`;

  const url = routes.get.chatsByDate + params;
  return axios.get(url, headers);
};

export const downloadVatAgreementUserIds = () => {
  const url = routes.get.vatAgreementUserIds;
  return axios.get(url, {
    ...headers,
    responseType: 'blob',
  });
};
